export default {

  //Home ---首页
  "smartCity.Home.943046-0": "Alarm",
  "smartCity.Home.943046-1": "Switch Homepage",
  "smartCity.Home.943046-2": "Are you sure to log out of the current account?",
  "smartCity.Home.943046-3": "Entry",
  "smartCity.Home.943046-4": "Recently alerted item list",
  "smartCity.Home.943046-5": "No alert information",
  "smartCity.Home.943046-6": "Recently alerted handling situation",
  "smartCity.Home.943046-7": "Handled", 
  "smartCity.Home.943046-8": "Handled today",
  "smartCity.Home.943046-9": "Handled today:",
  "smartCity.Home.943046-10": "Not handled today",
  "smartCity.Home.943046-11": "Not handled today:",
  "smartCity.Home.943046-12": "Number of equipment alarms",
  "smartCity.Home.943046-13": "Current alerted residents",
  "smartCity.Home.943046-14": "Number of currently alerted residents",
  "smartCity.Home.943046-15": "Current alerted equipment",
  "smartCity.Home.943046-16": "Number of currently alerted equipment",
  "smartCity.Home.943046-17": "List of equipment online",
  "smartCity.Home.943046-18": "Number of currently online equipment",
  "smartCity.Home.943046-19": "List of equipment offline",
  "smartCity.Home.943046-20": "Number of currently offline equipment",
  "smartCity.Home.943046-21": "Equipment status",
  "smartCity.Home.943046-22": "Equipment location",
  "smartCity.Home.943046-23": "Equipment name",
  "smartCity.Home.943046-24": "Switch status",
  "smartCity.Home.943046-25": "No status information",
  "smartCity.Home.943046-26": "Smart power usage",
  "smartCity.Home.943046-27": "Safe gas usage",
  "smartCity.Home.943046-28": "Operation log",
  "smartCity.Home.943046-29": "Time",
  "smartCity.Home.943046-30": "Equipment",
  "smartCity.Home.943046-31": "Operation",
  "smartCity.Home.943046-32": "No operation log",
  "smartCity.Home.943046-33": "System guide",
  "smartCity.Home.943046-34": "Mute",
  "smartCity.Home.943046-35": "Play",
  "smartCity.Home.943046-36": "Log out",
  "smartCity.Home.943046-37": "Equipment type",
  "smartCity.Home.943046-38": "Gas report",
  "smartCity.Home.943046-39": "Map mode",
  "smartCity.Home.943046-40": "Table mode",
  "smartCity.Home.943046-41": "Array mode",
  "smartCity.Home.943046-42": "Back",
  "smartCity.Home.943046-43": "Previous",
  "smartCity.Home.943046-44": "Next",
  "smartCity.Home.943046-45": "Unit",
  "smartCity.Home.943046-46": "Online devices",
  "smartCity.Home.943046-47": "Offline devices",
  "smartCity.Home.943046-48": "User list",
  "smartCity.Home.943046-49": "User count",
  "smartCity.Home.943046-50": "Household",
  "smartCity.Home.943046-51": "Number of unresolved alarms today",
  "smartCity.Home.943046-52": "Time",
  "smartCity.Home.943046-53": "Micro-cut device",
  "smartCity.Home.943046-54": "Micro-cut",
  "smartCity.Home.943046-55": "Gas sensor device",
  "smartCity.Home.943046-56": "Gas sensor",
  "smartCity.Home.943046-57": "Smoke sensor device",
  "smartCity.Home.943046-58": "Smoke sensor",
  "smartCity.Home.943046-59": "Gas valve device",
  "smartCity.Home.943046-60": "Gas valve",
  "smartCity.Home.943046-61": "Normal",
  "smartCity.Home.943046-62": "Alarm",
  "smartCity.Home.943046-63": "Username",
  "smartCity.Home.943046-64": "Search",
  "smartCity.Home.943046-65": "Clear",
  "smartCity.Home.943046-66": "Merchant",
  "smartCity.Home.943046-67": "Resident",
  "smartCity.Home.943046-68": "Qualified",
  "smartCity.Home.943046-69": "Unqualified",
  "smartCity.Home.943046-70": "View Image",
  "smartCity.Home.943046-71": "Edit",
  "smartCity.Home.943046-72": "Username:",
  "smartCity.Home.943046-73": "Area:",
  "smartCity.Home.943046-74": "Phone Number:",
  "smartCity.Home.943046-75": "User Address:",
  "smartCity.Home.943046-76": "Registration Time:",
  "smartCity.Home.943046-77": "Device Name",
  "smartCity.Home.943046-78": "Advanced Query",
  "smartCity.Home.943046-79": "Add New",
  "smartCity.Home.943046-80": "Digital Display",
  "smartCity.Home.943046-81": "Non-digital Display",
  "smartCity.Home.943046-82": "None",
  "smartCity.Home.943046-83": "Verification",
  "smartCity.Home.943046-84": "Calibration",
  "smartCity.Home.943046-85": "Conformity",
  "smartCity.Home.943046-86": "Non-conformity",
  "smartCity.Home.943046-87": "Delete",
  "smartCity.Home.943046-88": "Filter:",
  "smartCity.Home.943046-89": "Device Type",
  "smartCity.Home.943046-90": "Device Number",
  "smartCity.Home.943046-91": "On-line",
  "smartCity.Home.943046-92": "Offline",
  "smartCity.Home.943046-93": "Close",
  "smartCity.Home.943046-94": "Open",
  "smartCity.Home.943046-95": "Daily",
  "smartCity.Home.943046-96": "Site",
  "smartCity.Home.943046-97": "Annual inspection",
  "smartCity.Home.943046-98": "More",
  "smartCity.Home.943046-99": "Device name:",
  "smartCity.Home.943046-100": "Device number:",
  "smartCity.Home.943046-101": "Communication time:",
  "smartCity.Home.943046-102": "Location:",
  "smartCity.Home.943046-103": "Switch status:",
  "smartCity.Home.943046-104": "No devices available",
  "smartCity.Home.943046-105": "Real-time value",
  "smartCity.Home.943046-106": "Functional switch status:",
  "smartCity.Home.943046-107": "Battery type:",
  "smartCity.Home.943046-108": "Battery status:",
  "smartCity.Home.943046-109": "Battery remaining capacity:",
  "smartCity.Home.943046-110": "Monitoring status:",
  "smartCity.Home.943046-111": "Tampering:",
  "smartCity.Home.943046-112": "Humidity value:",
  "smartCity.Home.943046-113": "Temperature value:",
  "smartCity.Home.943046-114": "Power supply mode:",
  "smartCity.Home.943046-115": "Battery powered:",
  "smartCity.Home.943046-116": "Battery capacity:",
  "smartCity.Home.943046-117": "Battery voltage:",
  "smartCity.Home.943046-118": "Battery percentage:",
  "smartCity.Home.943046-119": "Alarm information",
  "smartCity.Home.943046-120": "Unprocessed",
  "smartCity.Home.943046-121": "False alarm",
  "smartCity.Home.943046-122": "Current value:",
  "smartCity.Home.943046-123": "Rated value:",
  "smartCity.Home.943046-124": "Difference:",
  "smartCity.Home.943046-125": "Alarm name:",
  "smartCity.Home.943046-126": "Alarm code:",
  "smartCity.Home.943046-127": "Alarm category:",
  "smartCity.Home.943046-128": "Additional information",
  "smartCity.Home.943046-129": "No data available",
  "smartCity.Home.943046-130": "Province",
  "smartCity.Home.943046-131": "City",
  "smartCity.Home.943046-132": "District",
  "smartCity.Home.943046-133": "Township",
  "smartCity.Home.943046-134": "Village",
  "smartCity.Home.943046-135": "Household",
  "smartCity.Home.943046-136": "Household phone",
  "smartCity.Home.943046-137": "Longitude",
  "smartCity.Home.943046-138": "Latitude",
  "smartCity.Home.943046-139": "Installation time",
  "smartCity.Home.943046-140": "P-series device",
  "smartCity.Home.943046-141": "Historical chart",
  "smartCity.Home.943046-142": "Voltage",
  "smartCity.Home.943046-143": "Current",
  "smartCity.Home.943046-144": "Temperature",
  "smartCity.Home.943046-145": "Active power",
  "smartCity.Home.943046-146": "Reactive power",
  "smartCity.Home.943046-147": "Leakage current",
  "smartCity.Home.943046-148": "Power consumption record",
  "smartCity.Home.943046-149": "Parameter setting",
  "smartCity.Home.943046-150": "Overcurrent protection",
  "smartCity.Home.943046-151": "Overcurrent trip setting",
  "smartCity.Home.943046-152": "Overcurrent warning setting",
  "smartCity.Home.943046-153": "Overcurrent trip delay",
  "smartCity.Home.943046-154": "Overcurrent warning delay",
  "smartCity.Home.943046-155": "Overcurrent warning tripping",
  "smartCity.Home.943046-156": "Trip",
  "smartCity.Home.943046-157": "No trip",
  "smartCity.Home.943046-158": "Overcurrent trip",
  "smartCity.Home.943046-159": "Overcurrent trip lockout",
  "smartCity.Home.943046-160": "Overload protection",
  "smartCity.Home.943046-161": "Overload trip setting",
  "smartCity.Home.943046-162": "Overload warning setting",
  "smartCity.Home.943046-163": "Overload trip delay",
  "smartCity.Home.943046-164": "Overload warning delay",
  "smartCity.Home.943046-165": "Overload warning tripping",
  "smartCity.Home.943046-166": "Overload trip",
  "smartCity.Home.943046-167": "Overload trip lockout",
  "smartCity.Home.943046-168": "Leakage protection",
  "smartCity.Home.943046-169": "Leakage trip setting",
  "smartCity.Home.943046-170": "Leakage warning setting",
  "smartCity.Home.943046-171": "Leakage trip delay",
  "smartCity.Home.943046-172": "Leakage warning delay",
  "smartCity.Home.943046-173": "Leakage warning tripping",
  "smartCity.Home.943046-174": "Leakage trip",
  "smartCity.Home.943046-175": "Overvoltage protection",
  "smartCity.Home.943046-176": "Overvoltage trip setting",
  "smartCity.Home.943046-177": "Overvoltage warning setting",
  "smartCity.Home.943046-178": "Overvoltage trip delay",
  "smartCity.Home.943046-179": "Overvoltage warning delay",
  "smartCity.Home.943046-180": "Overvoltage warning tripping",
  "smartCity.Home.943046-181": "Overvoltage trip",
  "smartCity.Home.943046-182": "Undervoltage protection",
  "smartCity.Home.943046-183": "Undervoltage trip setting",
  "smartCity.Home.943046-184": "Undervoltage warning setting",
  "smartCity.Home.943046-185": "Undervoltage trip delay",
  "smartCity.Home.943046-186": "Undervoltage warning delay",
  "smartCity.Home.943046-187": "Undervoltage warning tripping",
  "smartCity.Home.943046-188": "Undervoltage trip",
  "smartCity.Home.943046-189": "Overvoltage and undervoltage recovery",
  "smartCity.Home.943046-190": "Overvoltage recovery closing setting",
  "smartCity.Home.943046-191": "Under-voltage recovery closing setting",
  "smartCity.Home.943046-192": "Over-voltage recovery delay",
  "smartCity.Home.943046-193": "Under-voltage recovery delay",
  "smartCity.Home.943046-194": "Over-voltage recovery setting",
  "smartCity.Home.943046-195": "Under-voltage recovery setting",
  "smartCity.Home.943046-196": "Arc protection",
  "smartCity.Home.943046-197": "Arc trip setting",
  "smartCity.Home.943046-198": "Arc alarm setting",
  "smartCity.Home.943046-199": "Arc trip delay",
  "smartCity.Home.943046-200": "Arc alarm delay",
  "smartCity.Home.943046-201": "Arc alarm activation",
  "smartCity.Home.943046-202": "Arc trip activation",
  "smartCity.Home.943046-203": "Over-temperature protection",
  "smartCity.Home.943046-204": "Over-temperature trip setting",
  "smartCity.Home.943046-205": "Over-temperature alarm setting",
  "smartCity.Home.943046-206": "Over-temperature trip delay",
  "smartCity.Home.943046-207": "Over-temperature alarm delay",
  "smartCity.Home.943046-208": "Over-temperature alarm activation",
  "smartCity.Home.943046-209": "Over-temperature trip activation",
  "smartCity.Home.943046-210": "Phase loss protection",
  "smartCity.Home.943046-211": "Phase loss trip setting",
  "smartCity.Home.943046-212": "Phase loss alarm setting",
  "smartCity.Home.943046-213": "Phase loss trip delay",
  "smartCity.Home.943046-214": "Phase loss alarm delay",
  "smartCity.Home.943046-215": "Phase loss alarm activation",
  "smartCity.Home.943046-216": "Phase loss trip activation",
  "smartCity.Home.943046-217": "Sequential operation locking",
  "smartCity.Home.943046-218": "Locking time",
  "smartCity.Home.943046-219": "Operation times",
  "smartCity.Home.943046-220": "Three-phase over-voltage recovery",
  "smartCity.Home.943046-221": "Three-phase under-voltage recovery",
  "smartCity.Home.943046-222": "Over/under voltage recovery time",
  "smartCity.Home.943046-223": "System parameters",
  "smartCity.Home.943046-224": "Battery storage interval",
  "smartCity.Home.943046-225": "Immediate battery storage threshold",
  "smartCity.Home.943046-226": "Interval battery storage threshold",
  "smartCity.Home.943046-227": "Battery capacity",
  "smartCity.Home.943046-228": "Maximum upgrade reboot times",
  "smartCity.Home.943046-229": "Heartbeat abnormal reboot times",
  "smartCity.Home.943046-230": "Submit settings",
  "smartCity.Home.943046-231": "Quartz threshold",
  "smartCity.Home.943046-232": "Threshold 1",
  "smartCity.Home.943046-233": "Threshold 2",
  "smartCity.Home.943046-234": "Unbind?",
  "smartCity.Home.943046-235": "Password",
  "smartCity.Home.943046-236": "Silence the device?",
  "smartCity.Home.943046-237": "Silence",
  "smartCity.Home.943046-238": "Quartz",
  "smartCity.Home.943046-239": "Sure to trip?",
  "smartCity.Home.943046-240": "Sure to close?",
  "smartCity.Home.943046-241": "Close valve",
  "smartCity.Home.943046-242": "Probe",
  "smartCity.Home.943046-243": "Clock",
  "smartCity.Home.943046-244": "Loading...",
  "smartCity.Home.943046-245": "Username",
  "smartCity.Home.943046-246": "Detailed address",
  "smartCity.Home.943046-247": "Type",
  "smartCity.Home.943046-248": "Process",
  "smartCity.Home.943046-249": "No alarm message",
  "smartCity.Home.943046-250": "Serial number",
  "smartCity.Home.943046-251": "Property owner name",
  "smartCity.Home.943046-252": "Device address",
  "smartCity.Home.943046-253": "Communication time",
  "smartCity.Home.943046-254": "Online status",
  "smartCity.Home.943046-255": "Neighborhood",
  "smartCity.Home.943046-256": "Address",
  "smartCity.Home.943046-257": "Property owner name",
  "smartCity.Home.943046-258": "Contact number",
  "smartCity.Home.943046-259": "Alarm time",
  "smartCity.Home.943046-260": "No alarm residents",
  "smartCity.Home.943046-261": "Region",
  "smartCity.Home.943046-262": "Registration time",
  "smartCity.Home.943046-263": "No users",
  "smartCity.Home.943046-264": "Probe name",
  "smartCity.Home.943046-265": "Current concentration value",
  "smartCity.Home.943046-266": "Alarm status",
  "smartCity.Home.943046-267": "Creation time",
  "smartCity.Home.943046-268": "Alarm status",
  "smartCity.Home.943046-269": "Creation time",
  "smartCity.Home.943046-270": "No probe available",
  "smartCity.Home.943046-271": "Device details",
  "smartCity.Home.943046-272": "City",
  "smartCity.Home.943046-273": "Address",
  "smartCity.Home.943046-274": "Building",
  "smartCity.Home.943046-275": "Unit",
  "smartCity.Home.943046-276": "Floor",
  "smartCity.Home.943046-277": "User ID",
  "smartCity.Home.943046-278": "Owner phone",
  "smartCity.Home.943046-279": "Maintainer name",
  "smartCity.Home.943046-280": "Maintainer phone",
  "smartCity.Home.943046-281": "Maintainer ID number",
  "smartCity.Home.943046-282": "Maintenance time",
  "smartCity.Home.943046-283": "Maintenance information",
  "smartCity.Home.943046-284": "Maintainer ID photo",
  "smartCity.Home.943046-285": "Confirm",
  "smartCity.Home.943046-286": "Edit user",
  "smartCity.Home.943046-287": "Please enter building number",
  "smartCity.Home.943046-288": "Please enter unit number",
  "smartCity.Home.943046-289": "Please enter floor number",
  "smartCity.Home.943046-290": "Please enter user ID",
  "smartCity.Home.943046-291": "Please enter owner's name",
  "smartCity.Home.943046-292": "Please enter owner's phone number",
  "smartCity.Home.943046-293": "User type",
  "smartCity.Home.943046-294": "Please select user type",
  "smartCity.Home.943046-295": "Organization name",
  "smartCity.Home.943046-296": "Please enter organization name",
  "smartCity.Home.943046-297": "Area manager's phone number",
  "smartCity.Home.943046-298": "Please enter area manager's phone number",
  "smartCity.Home.943046-299": "Annual inspection status",
  "smartCity.Home.943046-300": "Please select annual inspection status.",
  "smartCity.Home.943046-301": "Search Address",
  "smartCity.Home.943046-302": "Please enter the detailed address",
  "smartCity.Home.943046-303": "Years of use",
  "smartCity.Home.943046-304": "Please enter the usage duration",
  "smartCity.Home.943046-305": "Area administrator",
  "smartCity.Home.943046-306": "Please enter the area administrator",
  "smartCity.Home.943046-307": "Calibration certificate validity",
  "smartCity.Home.943046-308": "Please select the date",
  "smartCity.Home.943046-309": "Whether there is a host or not?",
  "smartCity.Home.943046-310": "Please select",
  "smartCity.Home.943046-311": "Yes",
  "smartCity.Home.943046-312": "No",
  "smartCity.Home.943046-313": "Is there a platform",
  "smartCity.Home.943046-314": "Whether there is an SMS alert?",
  "smartCity.Home.943046-315": "Is there sound and light alarm",
  "smartCity.Home.943046-316": "Is there a cut-off",
  "smartCity.Home.943046-317": "Is there a cut off device",
  "smartCity.Home.943046-318": "Number of sensors",
  "smartCity.Home.943046-319": "Please enter the number of probes",
  "smartCity.Home.943046-320": "Legal entity name",
  "smartCity.Home.943046-321": "Please enter the name of the legal entity",
  "smartCity.Home.943046-322": "Please enter the contact phone number",
  "smartCity.Home.943046-323": "Date",
  "smartCity.Home.943046-325": "Self-check",
  "smartCity.Home.943046-327": "Power supply",
  "smartCity.Home.943046-328": "Routine inspection",
  "smartCity.Home.943046-329": "Alarm equipment operation status",
  "smartCity.Home.943046-330": "Fault",
  "smartCity.Home.943046-331": "Linked equipment operation status",
  "smartCity.Home.943046-332": "Reasons for alarm location and handling status",
  "smartCity.Home.943046-333": "Please enter",
  "smartCity.Home.943046-334": "Watchman",
  "smartCity.Home.943046-335": "Cancel",
  "smartCity.Home.943046-336": "Detector serial number",
  "smartCity.Home.943046-337": "Live Action Value Record",
  "smartCity.Home.943046-338": "Allowed",
  "smartCity.Home.943046-339": "Disposition",
  "smartCity.Home.943046-340": "Ready to use",
  "smartCity.Home.943046-341": "calibration",
  "smartCity.Home.943046-342": "Replace probe",
  "smartCity.Home.943046-343": "Spot checker",
  "smartCity.Home.943046-344": "Check test content",
  "smartCity.Home.943046-345": "Check test results",
  "smartCity.Home.943046-346": "Instrument self-test",
  "smartCity.Home.943046-347": "Exclusions",
  "smartCity.Home.943046-348": "Remarks",
  "smartCity.Home.943046-349": "Checker",
  "smartCity.Home.943046-350": "Device alarm",
  "smartCity.Home.943046-351": "Device '{0}' {2} alarm occurs in the {1}, please deal with it in time",
  "smartCity.Home.943046-352": "View details",
  "smartCity.Home.943046-353": "Edit Device",
  "smartCity.Home.943046-354": "Device Code",
  "smartCity.Home.943046-355": "Please enter device code",
  "smartCity.Home.943046-356": "Please enter device name",
  "smartCity.Home.943046-357": "Contacts",
  "smartCity.Home.943046-358": "Please enter a contact",
  "smartCity.Home.943046-359": "Device Pictures",
  "smartCity.Home.943046-360": "Are you sure you want to delete this image?",
  "smartCity.Home.943046-361": "Clock Settings",
  "smartCity.Home.943046-362": "Set Time",
  "smartCity.Home.943046-363": "Device clock",
  "smartCity.Home.943046-364": "Set clock",
  "smartCity.Home.943046-365": "Read clock",
  "smartCity.Home.943046-366": "Change Operation Password",
  "smartCity.Home.943046-367": "Original password",
  "smartCity.Home.943046-368": "Please enter password",
  "smartCity.Home.943046-369": "New Password",
  "smartCity.Home.943046-370": "confirm password",
  "smartCity.Home.943046-371": "New in-use gas alarm",
  "smartCity.Home.943046-372": "Edit gas alarm in use",
  "smartCity.Home.943046-373": "Display by",
  "smartCity.Home.943046-374": "Appliance Type",
  "smartCity.Home.943046-375": "Use Units",
  "smartCity.Home.943046-376": "Unified Social Credit Code of the User Unit",
  "smartCity.Home.943046-377": "Gas Supply Unit",
  "smartCity.Home.943046-378": "Model specifications",
  "smartCity.Home.943046-379": "factory number",
  "smartCity.Home.943046-380": "Manufacturer's Unified Social Credit Code",
  "smartCity.Home.943046-381": "manufacturer",
  "smartCity.Home.943046-382": "Type Approval Certificate Number",
  "smartCity.Home.943046-383": "Installation site",
  "smartCity.Home.943046-384": "Measurement traceability",
  "smartCity.Home.943046-385": "Measurement Traceability",
  "smartCity.Home.943046-386": "Measurement Date of Origin",
  "smartCity.Home.943046-387": "Certificate Number",
  "smartCity.Home.943046-388": "Metrology Performance Compliance",
  "smartCity.Home.943046-389": "Query",
  "smartCity.Home.943046-390": "Please enter drop-down items",
  "smartCity.Home.943046-391": "Modify",
  "smartCity.Home.943046-392": "Delete this drop-down?",
  "smartCity.Home.943046-393": "One-click import",
  "smartCity.Home.943046-394": "View",
  "smartCity.Home.943046-395": "Data Center",
  "smartCity.Home.943046-396": "Skip",
  "smartCity.Home.943046-397": "Zhejiang Province-Hangzhou",
  "smartCity.Home.943046-398": "User Address",
  "smartCity.Home.943046-399": "Number of gas alarms",
  "smartCity.Home.943046-400": "Number of gas solenoid valves",
  "smartCity.Home.943046-401": "Location",
  "smartCity.Home.943046-402": "Controller Operation",
  "smartCity.Home.943046-403": "Fire Protection Manager",
  "smartCity.Home.943046-404": "Device detection data",
  "smartCity.Home.943046-405": "Today's energy consumption time-sharing statistics",
  "smartCity.Home.943046-406": "Unit (kw·h)",
  "smartCity.Home.943046-407": "Please select smart power to enter the system",
  "smartCity.Home.943046-408": "Please select safe gas entry system",
  "smartCity.Home.943046-409": "Region selection",
  "smartCity.Home.943046-410": "Please select the city-level data you want to view",
  "smartCity.Home.943046-411": "Left Menu",
  "smartCity.Home.943046-412": "Select different left menus to view different levels of data",
  "smartCity.Home.943046-413": "upper label",
  "smartCity.Home.943046-414": "This button shows the upper area of the left menu, click to view the higher-level data",
  "smartCity.Home.943046-415": "This mode can perform operations on gas safety information content",
  "smartCity.Home.943046-416": "Gas filling main area",
  "smartCity.Home.943046-417": "The data at each level in this mode is displayed in the form of a map",
  "smartCity.Home.943046-418": "Map Mode Main Area",
  "smartCity.Home.943046-419": "The data at each level in this mode is displayed in the form of a table",
  "smartCity.Home.943046-420": "Double-click the list row data or click the user name to enter the device list interface",
  "smartCity.Home.943046-421": "No user data",
  "smartCity.Home.943046-422": "Device List",
  "smartCity.Home.943046-423": "Device data presented in tabular form",
  "smartCity.Home.943046-424": "Tap to return to the upper level",
  "smartCity.Home.943046-425": "Data at each level in this mode is displayed in the form of an array",
  "smartCity.Home.943046-426": "User Array",
  "smartCity.Home.943046-427": "Click on a piece of data to enter the device array interface",
  "smartCity.Home.943046-428": "Device array",
  "smartCity.Home.943046-429": "Device data presented in array",
  "smartCity.Home.943046-430": "hint",
  "smartCity.Home.943046-431": "Delete or not",
  "smartCity.Home.943046-432": "Please fill in the required fields first!",
  "smartCity.Home.943046-433": "Request timed out",
  "smartCity.Home.943046-434": "Daily Maintenance Inspection Record",
  "smartCity.Home.943046-435": "Annual (Quarterly) Inspection Records",
  "smartCity.Home.943046-436": "Probe List",
  "smartCity.Home.943046-437": "Operation password",
  "smartCity.Home.943046-438": "Please enter the operation password",
  "smartCity.Home.943046-439": "Original password cannot be empty",
  "smartCity.Home.943046-440": "New password cannot be empty",
  "smartCity.Home.943046-441": "Please confirm password",
  "smartCity.Home.943046-442": "The password is not the same twice",
  "smartCity.Home.943046-443": "Password changed successfully",
  "smartCity.Home.943046-444": "Your operation is too frequent, please wait a minute...",
  "smartCity.Home.943046-445": "In operation",
  "smartCity.Home.943046-446": "Quirting",
  "smartCity.Home.943046-447": "Please complete the required fields first",
  "smartCity.Home.943046-448": "Phase A voltage",
  "smartCity.Home.943046-449": "Phase B voltage",
  "smartCity.Home.943046-450": "C phase voltage",
  "smartCity.Home.943046-451": "Phase A current",
  "smartCity.Home.943046-452": "Phase B current",
  "smartCity.Home.943046-453": "C-phase current",
  "smartCity.Home.943046-454": "Phase A temperature",
  "smartCity.Home.943046-455": "Phase B temperature",
  "smartCity.Home.943046-456": "C phase temperature",
  "smartCity.Home.943046-457": "A-phase active power",
  "smartCity.Home.943046-458": "B-phase active power",
  "smartCity.Home.943046-459": "C-phase active power",
  "smartCity.Home.943046-460": "Total Active Power",
  "smartCity.Home.943046-461": "A-phase reactive power",
  "smartCity.Home.943046-462": "B-phase reactive power",
  "smartCity.Home.943046-463": "C-phase reactive power",
  "smartCity.Home.943046-464": "Total reactive power",
  "smartCity.Home.943046-465": "Please wait",
  "smartCity.Home.943046-466": "Unknown",
  "smartCity.Home.943046-467": "Processing situation",
  "smartCity.Home.943046-468": "Unresolved",
  "smartCity.Home.943046-469": "Resolved",
  "smartCity.Home.943046-470": "Number of devices",
  "smartCity.Home.943046-471": "Device anomalies in the last 7 days",
  "smartCity.Home.943046-472": "Number of anomalies",
  "smartCity.Home.943046-473": "Microsoft Yahei",
  "smartCity.Home.943046-474": "Docking successful!",
  "smartCity.Home.943046-475": "Docking failed!",
  "smartCity.Home.943046-476": "No authentication information found, please log in again",
  "smartCity.Home.943046-477": "False positive today",
  "smartCity.Home.943046-478": "Whether to the device $",



  // HomeBak1--数据模式
  "smartCity.HomeBak1.282798-0": "Switch Home",
  "smartCity.HomeBak1.282798-1": "Alert",
  "smartCity.HomeBak1.282798-2": "Do you want to log out of your current account?",
  "smartCity.HomeBak1.282798-3": "entrance",
  "smartCity.HomeBak1.282798-4": "Smart Electricity",
  "smartCity.HomeBak1.282798-5": "Safe gas",
  "smartCity.HomeBak1.282798-6": "The alarm of the day has been dealt with",
  "smartCity.HomeBak1.282798-7": "Device Location",
  "smartCity.HomeBak1.282798-8": "Device Name",
  "smartCity.HomeBak1.282798-9": "switch state",
  "smartCity.HomeBak1.282798-10": "No status information",
  "smartCity.HomeBak1.282798-11": "Operation log",
  "smartCity.HomeBak1.282798-12": "Time",
  "smartCity.HomeBak1.282798-13": "Action",
  "smartCity.HomeBak1.282798-14": "Device Type",
  "smartCity.HomeBak1.282798-15": "Safe Monitoring",
  "smartCity.HomeBak1.282798-16": "Device Status",
  "smartCity.HomeBak1.282798-17": "Device anomalies in the last 7 days",
  "smartCity.HomeBak1.282798-18": "List of historical alarm entries",
  "smartCity.HomeBak1.282798-19": "No alarm information",
  "smartCity.HomeBak1.282798-20": "Hangzhou, Zhejiang Province",
  "smartCity.HomeBak1.282798-21": "All Areas",
  "smartCity.HomeBak1.282798-22": "System operation",
  "smartCity.HomeBak1.282798-23": "Please select this function button to enter the background interface",
  "smartCity.HomeBak1.282798-24": "Change Data 1",
  "smartCity.HomeBak1.282798-25": "Change Data 2",
  "smartCity.HomeBak1.282798-26": "No details on door and window switchgear",
  "smartCity.HomeBak1.282798-27": "Line Device",
  "smartCity.HomeBak1.282798-28": "Offline device",
  "smartCity.HomeBak1.282798-29": "micro-break",
  "smartCity.HomeBak1.282798-30": "Qi",
  "smartCity.HomeBak1.282798-31": "smoke",
  "smartCity.HomeBak1.282798-32": "Gas solenoid valve",
  "smartCity.HomeBak1.282798-33": "processed",
  "smartCity.HomeBak1.282798-34": "unprocessed",
  "smartCity.HomeBak1.282798-35": "Outer Ring",
  "smartCity.HomeBak1.282798-36": "inner ring",
  "smartCity.HomeBak1.282798-37": "date",
  "smartCity.HomeBak1.282798-38": "Number of anomalies",
  "smartCity.HomeBak1.282798-39": "Zhejiang Province-Hangzhou",
  "smartCity.HomeBak1.282798-40": "username",
  "smartCity.HomeBak1.282798-41": "Contact number",
  "smartCity.HomeBak1.282798-42": "Unit Name",

  //农业模式
  "smartCity.Home_bak2.049016-0": "Alert",
  "smartCity.Home_bak2.049016-1": "Do you want to log out of your current account?",
  "smartCity.Home_bak2.049016-2": "entrance",
  "smartCity.Home_bak2.049016-3": "List of Recent Alarm Entries",
  "smartCity.Home_bak2.049016-4": "No alarm information",
  "smartCity.Home_bak2.049016-5": "Recent alarm has been handled",
  "smartCity.Home_bak2.049016-6": "Processed",
  "smartCity.Home_bak2.049016-7": "Processed today",
  "smartCity.Home_bak2.049016-8": "Today's Processing:",
  "smartCity.Home_bak2.049016-9": "Unprocessed today",
  "smartCity.Home_bak2.049016-10": "Unprocessed today:",
  "smartCity.Home_bak2.049016-11": "Number of device alarms",
  "smartCity.Home_bak2.049016-12": "Current Alarm Occupants",
  "smartCity.Home_bak2.049016-13": "Current number of alarmed households",
  "smartCity.Home_bak2.049016-14": "Current alarm device",
  "smartCity.Home_bak2.049016-15": "Current number of alarm devices",
  "smartCity.Home_bak2.049016-16": "Device Online List",
  "smartCity.Home_bak2.049016-17": "Current number of devices online",
  "smartCity.Home_bak2.049016-18": "Device offline list",
  "smartCity.Home_bak2.049016-19": "Number of devices currently offline",
  "smartCity.Home_bak2.049016-20": "Device Status",
  "smartCity.Home_bak2.049016-21": "Device Location",
  "smartCity.Home_bak2.049016-22": "Device Name",
  "smartCity.Home_bak2.049016-23": "Switch state",
  "smartCity.Home_bak2.049016-24": "No status information",
  "smartCity.Home_bak2.049016-25": "Smart Electricity",
  "smartCity.Home_bak2.049016-26": "Safe gas",
  "smartCity.Home_bak2.049016-27": "Operation log",
  "smartCity.Home_bak2.049016-28": "time",
  "smartCity.Home_bak2.049016-29": "Device",
  "smartCity.Home_bak2.049016-30": "Action",
  "smartCity.Home_bak2.049016-31": "No operation log",
  "smartCity.Home_bak2.049016-32": "Device Number",
  "smartCity.Home_bak2.049016-33": "user name",
  "smartCity.Home_bak2.049016-34": "Full address",
  "smartCity.Home_bak2.049016-35": "type",
  "smartCity.Home_bak2.049016-36": "Please handle",
  "smartCity.Home_bak2.049016-37": "Processing",
  "smartCity.Home_bak2.049016-38": "false positive",
  "smartCity.Home_bak2.049016-39": "No alarm message",
  "smartCity.Home_bak2.049016-40": "Device Address",
  "smartCity.Home_bak2.049016-41": "Communication time",
  "smartCity.Home_bak2.049016-42": "closing",
  "smartCity.Home_bak2.049016-43": "Gate",
  "smartCity.Home_bak2.049016-44": "No device",
  "smartCity.Home_bak2.049016-45": "Online Status",
  "smartCity.Home_bak2.049016-46": "Online",
  "smartCity.Home_bak2.049016-47": "offline",
  "smartCity.Home_bak2.049016-48": "District",
  "smartCity.Home_bak2.049016-49": "Household Address",
  "smartCity.Home_bak2.049016-50": "Name of owner",
  "smartCity.Home_bak2.049016-51": "Contact number",
  "smartCity.Home_bak2.049016-52": "Alarm time",
  "smartCity.Home_bak2.049016-53": "building-$",
  "smartCity.Home_bak2.049016-54": "unit-$",
  "smartCity.Home_bak2.049016-55": "Lou-$",
  "smartCity.Home_bak2.049016-56": "Building {0} - Unit {1} - {2} - Room {3}",
  "smartCity.Home_bak2.049016-57": "No alarm households",
  "smartCity.Home_bak2.049016-58": "Device Details",
  "smartCity.Home_bak2.049016-59": "None",
  "smartCity.Home_bak2.049016-60": "City",
  "smartCity.Home_bak2.049016-61": "province",
  "smartCity.Home_bak2.049016-62": "City",
  "smartCity.Home_bak2.049016-63": "district",
  "smartCity.Home_bak2.049016-64": "Region",
  "smartCity.Home_bak2.049016-65": "address",
  "smartCity.Home_bak2.049016-66": "longitude",
  "smartCity.Home_bak2.049016-67": "latitude",
  "smartCity.Home_bak2.049016-68": "Building",
  "smartCity.Home_bak2.049016-69": "Unit",
  "smartCity.Home_bak2.049016-70": "floor",
  "smartCity.Home_bak2.049016-71": "user number",
  "smartCity.Home_bak2.049016-72": "Owner's Name",
  "smartCity.Home_bak2.049016-73": "Owner Phone",
  "smartCity.Home_bak2.049016-74": "Name of repairer",
  "smartCity.Home_bak2.049016-75": "Maintenance Phone",
  "smartCity.Home_bak2.049016-76": "Repair person's ID number",
  "smartCity.Home_bak2.049016-77": "Repair time",
  "smartCity.Home_bak2.049016-78": "Repair Information",
  "smartCity.Home_bak2.049016-79": "Picture of the ID card of the repairer",
  "smartCity.Home_bak2.049016-80": "OK",
  "smartCity.Home_bak2.049016-81": "Alarm Information",
  "smartCity.Home_bak2.049016-82": "Device alarm",
  "smartCity.Home_bak2.049016-83": "Device '{0}' {2} alarm occurs in the {1}, please deal with it in time",
  "smartCity.Home_bak2.049016-84": "View details",
  "smartCity.Home_bak2.049016-85": "Docking successful!",
  "smartCity.Home_bak2.049016-86": "Docking failed!",
  "smartCity.Home_bak2.049016-87": "Authentication information not found, please log in again",
  "smartCity.Home_bak2.049016-88": "Processing situation",
  "smartCity.Home_bak2.049016-89": "Unprocessed",
  "smartCity.Home_bak2.049016-90": "Today's false positive",
  "smartCity.Home_bak2.049016-91": "hint",
  "smartCity.Home_bak2.049016-92": "Do you want to make $",

  //设备详情
  "smartCity.HomeBakDeviceDetail.479422-0": "Product Brief",
  "smartCity.HomeBakDeviceDetail.479422-1": "Device Details",
  "smartCity.HomeBakDeviceDetail.479422-2": "Energy Consumption Statistics",
  "smartCity.HomeBakDeviceDetail.479422-3": "Nanyang",
  "smartCity.HomeBakDeviceDetail.479422-4": "Zhoukou",
  "smartCity.HomeBakDeviceDetail.479422-5": "Battery",
  "smartCity.HomeBakDeviceDetail.479422-6": "voltage",
  "smartCity.HomeBakDeviceDetail.479422-7": "current",
  "smartCity.HomeBakDeviceDetail.479422-8": "leakage",
  "smartCity.HomeBakDeviceDetail.479422-9": "Active Power",
  "smartCity.HomeBakDeviceDetail.479422-10": "Number of alarms",
  "smartCity.HomeBakDeviceDetail.479422-11": "Gas concentration",
  "smartCity.HomeBakDeviceDetail.479422-12": "Request timed out",
  "smartCity.HomeBakDeviceDetail.479422-13": "Energy Consumption",
  "smartCity.HomeBakDeviceDetail.479422-14": "Total",
  "smartCity.HomeBakDeviceDetail.479422-15": "Device",
  "smartCity.HomeBakDeviceDetail.479422-16": "inner ring",
  "smartCity.HomeBakDeviceDetail.479422-17": "date",
  "smartCity.HomeBakDeviceDetail.479422-18": "Number of anomalies",

  //监控
  "smartCity.Monitor.549773-0": "Monitoring Device",
  "smartCity.Monitor.549773-1": "Device Location",
  "smartCity.Monitor.549773-2": "Device Number",
  "smartCity.Monitor.549773-3": "Device Name",
  "smartCity.Monitor.549773-4": "Is it online",
  "smartCity.Monitor.549773-5": "Online",
  "smartCity.Monitor.549773-6": "Not online",

  //设备列表
  "smartCity.HomeBakDeviceList.719300-0": "Device List",
  "smartCity.HomeBakDeviceList.719300-1": "Alarm Device",
  "smartCity.HomeBakDeviceList.719300-2": "Online Device",
  "smartCity.HomeBakDeviceList.719300-3": "Pending Device",
  "smartCity.HomeBakDeviceList.719300-4": "Recent alarm device",
  "smartCity.HomeBakDeviceList.719300-5": "Device Name",
  "smartCity.HomeBakDeviceList.719300-6": "Please enter device name",
  "smartCity.HomeBakDeviceList.719300-7": "Device Code",
  "smartCity.HomeBakDeviceList.719300-8": "Please enter device code",
  "smartCity.HomeBakDeviceList.719300-9": "Device Type",
  "smartCity.HomeBakDeviceList.719300-10": "search",
  "smartCity.HomeBakDeviceList.719300-11": "Device Location",
  "smartCity.HomeBakDeviceList.719300-12": "Device Number",
  "smartCity.HomeBakDeviceList.719300-13": "Communication time",
  "smartCity.HomeBakDeviceList.719300-14": "Is it online",
  "smartCity.HomeBakDeviceList.719300-16": "Action",
  "smartCity.HomeBakDeviceList.719300-17": "Online",
  "smartCity.HomeBakDeviceList.719300-18": "offline",
  "smartCity.HomeBakDeviceList.719300-19": "Are you sure you want to silence the device?",
  "smartCity.HomeBakDeviceList.719300-20": "silenced",
  "smartCity.HomeBakDeviceList.719300-21": "Summoning",
  "smartCity.HomeBakDeviceList.719300-22": "Are you sure you want to open the gate?",
  "smartCity.HomeBakDeviceList.719300-23": "Switch",
  "smartCity.HomeBakDeviceList.719300-24": "Are you sure it's closed?",
  "smartCity.HomeBakDeviceList.719300-25": "Close",
  "smartCity.HomeBakDeviceList.719300-26": "Are you sure you want to close the valve?",
  "smartCity.HomeBakDeviceList.719300-27": "Close valve",
  "smartCity.HomeBakDeviceList.719300-28": "probe",
  "smartCity.HomeBakDeviceList.719300-29": "Modify",
  "smartCity.HomeBakDeviceList.719300-30": "Unbind?",
  "smartCity.HomeBakDeviceList.719300-31": "delete",
  "smartCity.HomeBakDeviceList.719300-32": "Details",
  "smartCity.HomeBakDeviceList.719300-33": "No device information",
  "smartCity.HomeBakDeviceList.719300-34": "Owner's Name",
  "smartCity.HomeBakDeviceList.719300-35": "Device Address",
  "smartCity.HomeBakDeviceList.719300-36": "Serial number",
  "smartCity.HomeBakDeviceList.719300-37": "Abnormal Time",
  "smartCity.HomeBakDeviceList.719300-38": "processing",
  "smartCity.HomeBakDeviceList.719300-39": "false positive",
  "smartCity.HomeBakDeviceList.719300-40": "user name",
  "smartCity.HomeBakDeviceList.719300-41": "Full Address",
  "smartCity.HomeBakDeviceList.719300-42": "type",
  "smartCity.HomeBakDeviceList.719300-43": "Please select",
  "smartCity.HomeBakDeviceList.719300-44": "Micro-broken device",
  "smartCity.HomeBakDeviceList.719300-45": "Gas Sensing Device",
  "smartCity.HomeBakDeviceList.719300-46": "Smoke Sensing Device",
  "smartCity.HomeBakDeviceList.719300-47": "Gas Solenoid Valve",
  "smartCity.HomeBakDeviceList.719300-48": "Change Subscript",
  "smartCity.HomeBakDeviceList.719300-49": "Change the size per page",
  "smartCity.HomeBakDeviceList.719300-50": "Request timed out",
  "smartCity.HomeBakDeviceList.719300-51": "Operation password",
  "smartCity.HomeBakDeviceList.719300-52": "Please enter the operation password",
  "smartCity.HomeBakDeviceList.719300-53": "Your operation is too frequent, please wait a minute...",
  "smartCity.HomeBakDeviceList.719300-54": "In operation",
  "smartCity.HomeBakDeviceList.719300-55": "hint",
  "smartCity.HomeBakDeviceList.719300-56": "Quirting",
  "smartCity.HomeBakDeviceList.719300-57": "item device",
  "smartCity.HomeBakDeviceList.719300-58": "Whether to the device $",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/En/smartCity-en.js